import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';
import NumberFormat from 'react-currency-format';

const column1 = [
  {
    Header: 'Award Date',
    accessor: 'awardDate',
  },
  {
    Header: 'Contract Number',
    accessor: 'contractNumber',
  },
  {
    Header: 'NIIN',
    accessor: 'niin',
  },

  {
    Header: 'CAGE',
    accessor: 'cage',
  },
  {
    Header: 'Company Name',
    accessor: 'company',
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },

  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellProps => (
      <NumberFormat
        value={cellProps.original.unitPrice || '-'}
        displayType="text"
        thousandSeparator=","
        prefix="$"
      />
    ),
  },
  {
    Header: 'UI',
    accessor: 'UI',
  },
  {
    Header: 'Total Value',
    accessor: 'totalValue',
    Cell: cellProps => (
      <NumberFormat
        value={cellProps.original.totalValue || '-'}
        displayType="text"
        thousandSeparator=","
        prefix="$"
      />
    ),
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  console.log(toggleQuestion);
  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          <div>
            Supplier Procurement History
            <p style={{ fontSize: '14px' }}>
              (limited to 25 rows - Search by CAGE in Procurement History Search
              for complete list.)
            </p>
          </div>
          {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>
        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>

      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/CageDetailsTables/contractHistory.jsx